import React, { PureComponent, ReactNode } from "react";

import { IUserRecoverPasswordProps } from "../../../../../hoc/persister/userRecoverPassword/userRecoverPassword";
import PopupConfirmation from "../PopupConfirmation";
import PopupForm from "../PopupForm";

export interface IProps extends IUserRecoverPasswordProps {
  defaultEmail: string;
  onClose: () => void;
  open: boolean;
}

interface IState {
  emailRecovery: string;
  isFormCompleted: boolean;
}

export default class PasswordRecoveryFunnel extends PureComponent<
  IProps,
  IState
> {
  public state: IState = {
    emailRecovery: "",
    isFormCompleted: false,
  };

  private mounted: boolean = false;

  public componentDidMount(): void {
    this.mounted = true;
  }
  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public componentDidUpdate(prevProps: IProps): void {
    const { open } = this.props;

    if (open && !prevProps.open) {
      this.setState({
        isFormCompleted: false,
      });
    }
  }

  public handleFormConfirm = async (email: string): Promise<void> => {
    const { error } = await this.props.userRecoverPassword(email);

    if (this.mounted && !error) {
      this.setState({ emailRecovery: email, isFormCompleted: true });
    }
  };

  public render(): ReactNode {
    const { defaultEmail, onClose, open, recoveringPassword } = this.props;
    const { emailRecovery, isFormCompleted } = this.state;

    if (!open) {
      return null;
    }

    return (
      <>
        <PopupForm
          defaultEmail={defaultEmail}
          onConfirm={this.handleFormConfirm}
          onClose={onClose}
          open={!isFormCompleted}
          loading={recoveringPassword}
        />
        <PopupConfirmation
          email={emailRecovery}
          onClose={onClose}
          open={isFormCompleted}
        />
      </>
    );
  }
}
